<template>
  <a-modal v-if="loaded" class="note-show-modal"
           :visible="visible"
           width="60%"
           :closable="false"
           v-bind:class="{loaded: loaded}"
           @cancel="handleClose">
    <template slot="title">
      <div style="font-size: 15px">{{ note.title }}</div>
      <div style="font-size: 15px">Aangemaakt onder:
        <a :href="parent.uri">{{ parent.description }} {{ parent.name }}</a>
      </div>
      <div style="font-size: 15px">Aangemaakt door: <a
          href="#">{{ user.fullname }}</a>
        op {{ noteDatetime }}
      </div>
      <div class="title" style="font-size: 18px">
        <ShowProductLabelComponent
          v-for="(productLabel, key) in productLabels"
          :key="key"
          :product-label="productLabel"
        />
      </div>
    </template>
    <template>
      <p class="content note-content-wrap">
        {{ note.content }}
      </p>
    </template>
    <template slot="footer">
      <a-button @click="handleClose">
        Sluiten
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import NoteApi from "~/api/note";
import ShowProductLabelComponent from "~/modules/product_label/components/ShowProductLabelComponent"
import DateFormatEnum from '~/enums/DateFormatEnum';
import moment from 'moment'

export default {
  name: "ShowNoteModal",
  components: {ShowProductLabelComponent},
  props: {
    noteObject: {
      type: Object,
      default: null
    },
    noteId: {
      type: [Number, String],
      default: null
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      note: this.noteObject,
      loaded: false
    }
  },
  computed: {
    productLabels() {
      if (this.note !== null && typeof this.note.product_labels !== 'undefined' && this.note.product_labels !== null) {
        return this.note.product_labels.data;
      }
      return [];
    },
    noteDatetime() {
      if (this.note !== null && this.note.datetime !== null) {
        return this.note.datetime ? moment(this.note.datetime).format(DateFormatEnum.DATE) : ''
      }
    },
    user() {
      if (this.note !== null && typeof this.note.user !== 'undefined' && this.note.user !== null) {
        return this.note ? this.note.user.data : {}
      }
      return {};
    },
    parent() {
      if (this.note !== null && typeof this.note.attachable !== 'undefined' && this.note.attachable !== null
          && typeof this.note.attachable.data !== 'undefined' && this.note.attachable.data !== null
          && typeof this.note.attachable.data.parent_instance !== 'undefined' && this.note.attachable.data.parent_instance !== null) {
        return this.note ? this.note.attachable.data.parent_instance.data : {}
      }
      return {};
    },

  },
  methods: {
    handleClose() {
      this.$emit('close');
    },

  },
  mounted() {
    if (this.noteObject !== null) {
      this.loaded = true;
    } else if (this.noteId !== null) {
      NoteApi.find(this.noteId, ['product_labels', 'user', 'attachable.parent_instance']).then((response) => {
        this.note = response.data
        this.loaded = true;
      })
    } else {
      throw new Error('Either the note object or note id is required.');
    }
  }
}
</script>
<style>
.note-content-wrap {
  white-space: pre-wrap;
}
</style>
